
import './App.css';
import './Components/GithubSearch';
import GithubSearch from './Components/GithubSearch';

function App() {
  return (
    <div className="App">
      
    {/* <h1>Hello React</h1> */}
    <GithubSearch/>
    </div>
  );
}

export default App;
